import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';

export function HOOK_GRID2D_CELL__image_select(cell: DTO__grid2d_cell) {
  const dispatch = use_dispatch();
  const { g_image_edit__select__image_asset, g_general__layout, g_image_edit__tab } = use_slice_ui([
    'g_image_edit__select__image_asset',
    'g_general__layout',
    'g_image_edit__tab',
  ]);

  function on_click__image_select() {
    if (cell.is_stub()) return; //nothing to select
    if (cell.hash_sha256_content.is_empty_hash_sha256()) return; //nothing to select
    if (cell.image.is_stub()) return; //nothing to select
    if (g_image_edit__select__image_asset.hash_sha256_content == cell.hash_sha256_content) return; //already selected
    if (g_general__layout != ENUM__page_generation_layout.ASSETS) return null;
    if (g_image_edit__tab != ENUM__page_generation_layout_images_edit_tab.SELECT) return null;

    dispatch(LOCAL__ui_set_image({ key: 'g_image_edit__select__image_asset', value: cell.image }));
  }

  return { on_click__image_select };
}
